(function(){
    'use strict';

    angular.module('Directives').directive('bbaQuoteBaseZone', bbaQuoteBaseZone);
    
    bbaQuoteBaseZone.$inject = [
        '$timeout',
        'ServiceProfileZoneBaseTableService',
    ];

    function bbaQuoteBaseZone(
        $timeout,
        ServiceProfileZoneBaseTableService,
        
    )
    {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/components/margins/bba-quote-base-zone.html',
            require: ['^form', '^ngModel'],
            scope: {
                clearTable: '=?',
                isViewMode: '=?',
                ngModel: '=',
                ngOriginalData: '='
            },
            link: bbaQuoteBaseZoneLink
        }

        function bbaQuoteBaseZoneLink($scope, element, attr, ngModels){
            $scope.serviceProfileZoneBaseTableService = new ServiceProfileZoneBaseTableService(
                ngModels[0],
                $scope.ngModel
            );

            $scope.addNewMargin = $scope.serviceProfileZoneBaseTableService.addNewMargin;
            $scope.zoneTable = $scope.serviceProfileZoneBaseTableService.tableData;

            $scope.$watch('ngModel', (newValue, oldValue) => {
                if(newValue && angular.getObjVal(newValue, 'zoneFilters.regions')){
                    $scope.zoneTable = new ServiceProfileZoneBaseTableService(
                        ngModels[0],
                        $scope.ngModel
                    );
                    $scope.addNewMargin = $scope.serviceProfileZoneBaseTableService.addNewMargin;
                    $scope.zoneTable = $scope.serviceProfileZoneBaseTableService.tableData;
                }
            });

            $scope.$watch('clearTable', function(value){
                if(value) {
                    let orignalCarrierProfile = $scope.ngOriginalData ? $scope.ngOriginalData.carrierProfile : undefined;
                    let newCarrierProfile = $scope.ngModel.carrierProfile;
                    if(angular.equals(orignalCarrierProfile, newCarrierProfile)){
                        $scope.serviceProfileZoneBaseTableService.resetTableData();
                    }
                    else {
                        $scope.postcodeTable.data = [];
                        $scope.ngModel.regionsRaw = [];
                        $scope.clearTable = false;
                    }
                }
            });

            let listener = $scope.$on('zoneTableUpdated', function(data){
                $timeout(function(){
                    $scope.ngModel.zoneFiltersRaw = $scope.serviceProfileZoneBaseTableService.getZoneFormatted();
                    $scope.ngModel.zoneFiltersFrmOpen = $scope.serviceProfileZoneBaseTableService.getOpenForms();
                });
            });

            $scope.$on('$destroy', function(){
                listener();
            });
        }
    }
})();


// WEBPACK FOOTER //
// ./js/directives/component/margins/bbaQuoteBaseZone.js